import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Element } from '../../../../../common/html/element'
import { Radio } from '../../../../../common/html/radio'
import { ErrorMessage } from '../../errorMessage'
import { Input } from '../../input'

export const SaveFormOption = ({
  isSaveAs,
  setIsSaveAs,
  name,
  handleChangeName,
  applyingCriteriaName,
  error,
  isLoading,
}) => {
  return (
    <Element>
      <Element>
        <Radio
          title="screening.SAVE_CHANGE_TO"
          translateProps={{
            name: applyingCriteriaName,
            className: 'breakWord',
          }}
          value={false}
          activeValue={isSaveAs}
          onChange={setIsSaveAs}
          titleStyle={{ fontWeight: 600, color: '#3A414B' }}
        />
      </Element>
      <Element style={{ marginTop: 14 }}>
        <Radio
          title="screening.SAVE_AS"
          value={true}
          activeValue={isSaveAs}
          onChange={setIsSaveAs}
          titleStyle={{ fontWeight: 600, color: '#3A414B' }}
        />
        <Element className="mt1 ml3">
          <Input
            noControl
            value={name}
            onChange={(e) => handleChangeName(e.target.value)}
            disabled={isLoading || !isSaveAs}
            placeholder={UseI18n('screening.ENTER_CRITERIA_NAME')}
            wrapperStyle={{ backgroundColor: '#FFFFFF' }}
          />
          <ErrorMessage value={error} isI18n={false} />
        </Element>
      </Element>
    </Element>
  )
}
